import { render, staticRenderFns } from "./PosCustomerPicker.vue?vue&type=template&id=7d962344&scoped=true"
import script from "./PosCustomerPicker.vue?vue&type=script&lang=js"
export * from "./PosCustomerPicker.vue?vue&type=script&lang=js"
import style0 from "./PosCustomerPicker.vue?vue&type=style&index=0&id=7d962344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d962344",
  null
  
)

export default component.exports